import { Stack } from '@mui/material';
import { ReactNode } from 'react';
const Container = ({
  children
}: {
  children: ReactNode;
}) => {
  return <Stack sx={{
    width: '100%',
    maxWidth: 1200,
    alignItems: 'center',
    gap: 'var(--spacing_m)',
    m: 'auto',
    px: {
      xs: 'var(--spacing_m)',
      lg: 'var(--spacing_l)'
    }
  }} data-sentry-element="Stack" data-sentry-component="Container" data-sentry-source-file="Container.tsx">
      {children}
    </Stack>;
};
export default Container;